function collectSearchableText(value, seen = new WeakSet()) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value);
  }
  if (value instanceof Date) return value.toISOString();
  if (typeof value !== 'object') return '';
  if (seen.has(value)) return '';
  seen.add(value);
  if (Array.isArray(value)) {
    return value.map((item) => collectSearchableText(item, seen)).join(' ');
  }
  return Object.values(value)
    .map((item) => collectSearchableText(item, seen))
    .join(' ');
}

export function requestSearch(
  searchedVal,
  data,
  setRowsData,
  searchFields,
  startDate,
  endDate,
  choosenModel
) {
  let filteredRows = [];

  const needle = searchedVal.trim().toLowerCase();

  if (needle.length === 0) {
    filteredRows = data;
  } else {
    for (const row of data) {
      let haystack;
      if (!searchFields || searchFields.length === 0) {
        haystack = collectSearchableText(row);
      } else {
        haystack = searchFields
          .map((field) => collectSearchableText(row?.[field]))
          .join(' ');
      }
      if (haystack.toLowerCase().includes(needle)) {
        filteredRows.push(row);
      }
    }
  }

  if (startDate || endDate) {
    filteredRows = filteredRows.filter((log) => {
      const logDate = new Date(log.created_at);
      const startDateObj = new Date(startDate);
      const endDateObj = new Date(endDate);
      return (
        (!startDate || logDate >= startDateObj) &&
        (!endDate || logDate <= endDateObj)
      );
    });
  }

  if (choosenModel) {
    filteredRows = filteredRows.filter((item) => item.model === choosenModel);
  }

  setRowsData(filteredRows);
}
